import type { CorrectComponentType } from "@brytdesigns/web-component-core/utils";

import { createEffect, on } from "solid-js";
import { provideAjaxCartContext } from "../hooks/useAjaxCart.js";
import { traverseObject } from "../utils/index.js";

export type Props = {
  debug?: boolean;
};

export const Name = "cart-context";

export const Component: CorrectComponentType<Props> = (props, { element }) => {
  const cart = provideAjaxCartContext(element);

  createEffect(() => {
    if (!props.debug) return;
    const c = cart();
    // This will listen to every change within the cart object.
    traverseObject(c);
    console.log(`${Name}:updated!`, c);
  });
};
